import React, { useState, useEffect } from 'react'
// import LoginTailwind from "./pages/LoginTailwind";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Portfolio from "./pages/Portfolio";
import Watchlist from "./pages/Watchlist";
import Position from "./pages/Position";
import FNO from "./pages/FNO";
import Orders from "./pages/Orders";
import SignupWizard from "./pages/SignupWizard";
import CreateAccount from "./pages/CreateAccount";
import OrderHistory from "./pages/OrderHistory";
import MarketBanner from "./pages/MarketBanner";
import Rollover from "./pages/Rollover";
import LivePriceDocumentation from "./pages/LivePriceDocumentation";
import PrivateRoute from "./component/PrivateRoute"; // Add this import
import Loader from "./component/Loader"

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify'; // Add this import
import 'react-toastify/dist/ReactToastify.css'; // Add this import
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import '../node_modules/font-awesome/css/font-awesome.min.css';
 
import "./css/style.css";
import LoadingBar from 'react-top-loading-bar'; 
import Loader2 from './component/Loader2';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import { initI18n } from './i18n';

// Begin 
const App = () => {
  // Declaration
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  //----------------------------// useEffects //----------------------------//
  
  // Suppress ResizeObserver loop error
  useEffect(() => {
  // Suppress ResizeObserver errors completely
  const handleError = (e) => {
    if (
      e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded'
    ) {
      const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
      const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
      if (resizeObserverErr) resizeObserverErr.style.display = 'none';
      if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = 'none';
      
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  };

  // Add listener with capture phase
  window.addEventListener('error', handleError, true);
  
  // Also handle unhandled promise rejections
  const handleRejection = (e) => {
    if (e.reason?.message?.includes('ResizeObserver')) {
      e.preventDefault();
    }
  };
  
  window.addEventListener('unhandledrejection', handleRejection);

  return () => {
    window.removeEventListener('error', handleError, true);
    window.removeEventListener('unhandledrejection', handleRejection);
  };
}, []);




  useEffect(() => {
    const handleError = (e) => {
      if (e.message && e.message.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
      }
    };

    window.addEventListener('error', handleError);
    
    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  useEffect(() => {
    simulateDataLoad();
  }, [])

  //----------------------------// Functions //----------------------------//
  const simulateDataLoad = async () => {
    setProgress(30);

    try {
      await initI18n();
    } catch (e) {
      console.error(e);
    }

    // Simulating data loading
    setTimeout(() => {
      setProgress(70);

      setTimeout(() => {
        setProgress(100);
        setIsLoading(false);
      }, 800);
    }, 1000);
  };

  //----------------------------// Return Main //----------------------------// 
  return (
    <>
     {isLoading && (
        <div> 
          <Loader2 
            color="#FCB633" 
            progress={progress} 
            onLoaderFinished={() => setProgress(0)} 
          /> 
        </div>
      )}

      

      
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login setProgress={setProgress} />} />
          <Route path="/SignUp" element={<SignupWizard setProgress={setProgress} />} />
          <Route path="/NewPassword" element={<ForgotPassword setProgress={setProgress} />} />
          {/* <Route path="/s2" element={<CreateAccount setProgress={setProgress} />} /> */}
          
          {/* Protected Routes */}
          <Route path="/Dashboard" element={
            <PrivateRoute>
              <Dashboard setProgress={setProgress} />
            </PrivateRoute>
          } />
          
          <Route path="/ChangePassword" element={
            <PrivateRoute>
              <ChangePassword setProgress={setProgress} />
            </PrivateRoute>
          } />
          
          {/* <Route path="/MarketBanner" element={
            <PrivateRoute>
              <MarketBanner setProgress={setProgress} />
            </PrivateRoute>
          } /> */}
          
          <Route path="/Portfolio" element={
            <PrivateRoute>
              <Portfolio setProgress={setProgress} />
            </PrivateRoute>
          } />
        
          <Route path="/watchlist" element={
            <PrivateRoute>
              <Watchlist setProgress={setProgress} />
            </PrivateRoute>
          } />

       

          <Route path="/Position" element={
            <PrivateRoute>
              <Position setProgress={setProgress} />
            </PrivateRoute>
          } />

          <Route path="/FNO" element={
            <PrivateRoute>
              <FNO setProgress={setProgress} />
            </PrivateRoute>
          } />

          <Route path="/Order" element={
            <PrivateRoute>
              <Orders setProgress={setProgress} />
            </PrivateRoute>
          } /> 

          <Route path="/OrderHistory" element={
            <PrivateRoute>
              <OrderHistory setProgress={setProgress} />
            </PrivateRoute>
          } /> 

          <Route path="/Rollover" element={
            <PrivateRoute>
              <Rollover setProgress={setProgress} />
            </PrivateRoute>
          } /> 

          <Route path="/LPD" element={
            <PrivateRoute>
              <LivePriceDocumentation setProgress={setProgress} />
            </PrivateRoute>
          } /> 

          <Route path="/Loader" element={
            <PrivateRoute>
              <Loader2 setProgress={setProgress} /> 
            </PrivateRoute>
          } /> 
 
        </Routes> 
        
      </Router>
        {/* Toast Container for notifications */}
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          toastStyle={{ width: "400px" }}
        />
    </>
  ); 
};

export default App;
